import Checkbox from '@material-ui/core/Checkbox';
import React from 'react';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { PropTypes } from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

export const styles = () => ({
	root: {
		display: 'block',
	},
	sizeIcon: {
		fontSize: 35,
	},
});

const ReduxFormCheckbox = ({
	classes,
	biggerCheckbox,
	description,
	input: { value, ...otherInput },
	label,
	labelShrink,
	meta: { error, touched },
	required,
	...custom
}) => (
	<FormControl className={classes.root} error={touched && !!error}>
		<FormControlLabel
			label={label}
			control={
				<Checkbox
					checked={value}
					className={biggerCheckbox ? classes.sizeIcon : null}
					{...otherInput}
					{...custom}
				/>
			}
		/>
		{(touched && !!error && <FormHelperText>{error}</FormHelperText>) ||
			(description && <FormHelperText>{description}</FormHelperText>)}
	</FormControl>
);

ReduxFormCheckbox.propTypes = {
	classes: PropTypes.shape({
		root: PropTypes.string,
	}).isRequired,
	biggerCheckbox: PropTypes.bool,
	description: PropTypes.string,
	input: PropTypes.shape({
		name: PropTypes.string.isRequired,
	}),
	label: PropTypes.string,
	labelShrink: PropTypes.bool,
	meta: PropTypes.shape({ touched: PropTypes.bool, error: PropTypes.string }),
	required: PropTypes.bool,
};

ReduxFormCheckbox.defaultProps = {
	biggerCheckbox: false,
	description: null,
	input: {},
	label: null,
	labelShrink: undefined,
	meta: {},
	required: false,
};

export default withStyles(styles, { name: 'ReduxFormInput' })(ReduxFormCheckbox);
